import React from 'react';
import styles from './toolbar.module.css';

/** Pushes everything after it to the right edge of the bar. */
export const ToolbarSpacer: React.FC = () => <div className={styles.spacer} />;

/** Thin vertical divider, typically before the right-zone action buttons. */
export const ToolbarDivider: React.FC = () => <div className={styles.divider} />;

/** Muted right-aligned text, e.g. a result count. */
export const ToolbarCount: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={styles.count}>{children}</span>
);
